import React, {ReactNode} from 'react';
import OrgEmployeeFamilySaleMain from './OrgEmployeeFamilySaleMain';
import Page, {PageType} from '@episerver/spa-core/Page';
import OrgEmployeeFamilySalePageData from '../../../Models/Content/OrgEmployeeFamilySalePageData';

export default class OrgEmployeeFamilySalePage extends Page<OrgEmployeeFamilySalePageData> {
  public render(): ReactNode | null {
    return <OrgEmployeeFamilySaleMain context={this.getContext()} iContent={this.props.data} />;
  }
}
